import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Menu, MenuItem } from "@mui/material";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";

const AccountMenu = ({ anchorEl, open, onClose }) => {
  const navigate = useNavigate();
  const menuRef = useRef(null);

  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    onClose();
    navigate(window.location.pathname, { replace: true });
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      ref={menuRef}
    >
      <MenuItem onClick={() => handleLogout()}>
        <ExitToAppIcon sx={{ color: "primary.main", marginRight: 1 }} /> Sair
      </MenuItem>
    </Menu>
  );
};

export default AccountMenu;
